import { colorMapperWithoutProps, devices } from "src/styles";
import styled, { css } from "styled-components";

export const RightDisplay = styled.div<{
  backgroundSrc?: string;
  backgroundColor?: string;
}>`
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  min-height: 50vh;
  width: 100%;
  position: relative;

  ${(props) =>
    props.backgroundSrc &&
    css`
      background-image: url(${props.backgroundSrc});
      &::after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.75);
      }
    `}

  ${(props) =>
    props.backgroundColor &&
    css`
      background-color: ${colorMapperWithoutProps(
        props.backgroundColor,
        "primary"
      )};
    `}

 
  ${devices.desktop} {
    min-height: 100vh;
    width: 50vw;
    position: absolute;
    right: 0;
    top: 0;
  }
`;

export const BannerContent = styled.div<{ biggerTopMargin?: boolean }>`
  position: relative;
  z-index: 1;
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 50vh;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  text-align: center;

  ${(props) =>
    props.biggerTopMargin
      ? css`
          justify-content: center;
        `
      : css`
          justify-content: flex-start;
        `}

  ${devices.desktop} {
    padding: 45px 0 0 45px;
    text-align: left;
    justify-content: flex-start;

    ${(props) =>
      props.biggerTopMargin
        ? css`
            margin-top: 20vh;
          `
        : css`
            justify-content: center;
          `}
  }
`;

export const BottomLogo = styled.div`
  position: absolute;
  bottom: 50px;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  max-width: 200px;
  z-index: 1;
`;

export const TopLogo = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  max-width: 200px;
  z-index: 1;

  ${devices.desktop} {
    top: 10vh;
  }
`;
